import { message } from "antd";
import classNames from "classnames";
import { Else, If, Then, When } from "react-if";
import { deletePin } from "../../services";
import imageUrl from "../../utils/imageUrl";
import HBMessage from "../HBMessage";
import styles from "./index.module.less";

const MESSAGE_KEY = "pinSuccessMessageKey";

const PinSuccessMessage = {
  /**
   *
   * @param {{
   *  pin: IPin,
   *  extra?: { link: string, subtitle: string, title: string } | null,
   *  onUndo?: (pin: IPin) => void
   *  hideButton?: boolean
   * }} param0
   */
  open: ({ pin, extra, hideButton, onUndo }) => {
    const onClick = async () => {
      await deletePin({ pin_id: pin.pin_id });
      message.destroy(MESSAGE_KEY);
      HBMessage.success("撤销成功");
      onUndo && onUndo(pin);
    };

    message.open({
      key: MESSAGE_KEY,
      className: styles.message,
      content: (
        <div className={styles.content}>
          <a
            className={styles.img}
            href={`/boards/${pin?.board?.board_id}`}
            target="_blank"
          >
            <img src={imageUrl(pin.file, { width: 48 })} alt={pin.raw_text} />
          </a>
          <div
            className={classNames([styles.info, extra ? styles.w150 : null])}
          >
            <If condition={extra}>
              <Then>
                <div className={styles.item}>
                  <div className={styles.subtitle}>已采集到</div>
                  <a
                    className={styles.title}
                    href={`/boards/${pin?.board?.board_id}`}
                    target="_blank"
                  >
                    {pin?.board?.title}
                  </a>
                </div>
                <div className={styles.item}>
                  <div className={styles.subtitle}>{extra?.subtitle}</div>
                  <a
                    className={styles.title}
                    href={extra?.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {extra?.title}
                  </a>
                </div>
              </Then>
              <Else>
                <div className={styles.subtitle}>已采集到</div>
                <a
                  className={styles.title}
                  href={`/boards/${pin?.board?.board_id}`}
                  target="_blank"
                >
                  {pin?.board?.title}
                </a>
              </Else>
            </If>
          </div>
          <When condition={!hideButton}>
            <div className={styles.button}>
              <a className={styles.undo} onClick={onClick}>
                撤销
              </a>
              <a
                className={styles.link}
                href={`/pins/${pin.pin_id}`}
                target="_blank"
              >
                查看采集
              </a>
            </div>
          </When>
        </div>
      ),
    });
  },
};

export default PinSuccessMessage;
